import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import '../styles/MainHeader.css';
import SideNavigation from "./Sidebar";
import PanelMenu from "./SidebarOryza";
import PettiPettiLogo from "./img/logo/pettipettilogo.png";
import PettiPettiHome from "./img/logo/home.png";

export default function MainHeader () {
    const [scrolled, setScrolled] = useState(false);
    const [isNavOpen, setIsNavOpen] = useState(false);
    const [showPanel, setShowPanel] = useState(false);
    
    useEffect(() => {
        const handleScroll = () => {
           setScrolled(window.scrollY > 50);
       };

        const handleResize = () => {
           // Auto-open only when width is exactly 1280
           setIsNavOpen(window.innerWidth === 1280);
       };

        // Initial check
        handleScroll();
        handleResize();

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleResize);

        return () => {
           window.removeEventListener('scroll', handleScroll);
           window.removeEventListener('resize', handleResize);
       };
    }, []);

    const toggleNav = () => {
        setIsNavOpen(!isNavOpen);
        setShowPanel(false); // Close panel when opening nav
    };

    const togglePanel = () => {
        setShowPanel(!showPanel);
        setIsNavOpen(false); // Close nav when opening panel
    };

    return (
        <>
            <header className={`transparent-header ${scrolled ? 'scrolled' : ''}`}>
                <div className="container-size">
                    <div className="row align-items-center" style={{ padding: "0px -2px", "--bs-gutter-x": "-1.5rem" }}>
                        <div className="col-lg-1 col-md-1 col-sm-2 mobi1">
                            <Link to="/" className="logo_normal">
                                <img
                                    src={PettiPettiLogo}
                                    alt="Petti Petti Logo"
                                    style={{
                                        height: "65px",
                                        width: "auto",
                                        filter: scrolled ? 'none' : 'brightness(0) invert(1)'
                                    }}
                                />
                            </Link>
                        </div>
                        <div className="col-lg-2 col-md-10 col-sm-8 mobi2">
                            <button 
                                className="menu_open destinations-btn"
                                onClick={togglePanel}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: 0
                                }}
                            >
                                <img 
                                    src={PettiPettiHome} 
                                    alt="Destinations" 
                                    width="150px" 
                                    style={{ filter: scrolled ? 'none' : 'brightness(0) invert(1)' }} 
                                />
                            </button>
                        </div>
                        <div className="col-lg-1 col-md-1 col-sm-2 mobi3">
                            <div className="hamburger2 open_close_nav_panel mobileonly" onClick={toggleNav} style={{ cursor: "pointer" }}>
                                <div className="hamburger-box">
                                    <div className="hamburger-inner" style={{
                                        backgroundColor: scrolled ? '#fff' : '#fff'
                                    }}></div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-8 col-md-8 col-sm-6 main-menu-nav">
                            <div className="main-menu">
                                <nav id="mainNav" style={{ fontSize: "0.75rem", fontFamily: "Poppins" }}>
                                    <ul>
                                        <li><a href="/" style={{ color: scrolled ? '#333' : '#fff', lineHeight: "22px" }}>HOME</a></li>
                                        <li><a href="/dining" style={{ color: scrolled ? '#333' : '#fff', lineHeight: "22px" }}>EAT & DRINK</a></li>
                                        <li><a href="/events" style={{ color: scrolled ? '#333' : '#fff', lineHeight: "22px" }}>EVENTS</a></li>
                                        <li><a href="/offers" style={{ color: scrolled ? '#333' : '#fff', lineHeight: "22px" }}>OFFERS</a></li>
                                        <li><a href="/gallery" style={{ color: scrolled ? '#333' : '#fff', lineHeight: "22px" }}>GALLERY</a></li>
                                        <li><a href="/about" style={{ color: scrolled ? '#333' : '#fff', lineHeight: "22px" }}>ABOUT US</a></li>
                                        <li><a href="/contact" style={{ color: scrolled ? '#333' : '#fff', lineHeight: "22px" }}>CONTACT US</a></li>
                                        <li><a href="/lounge" className="btn_1_outline" style={{ color: scrolled ? '#333' : '#fff', lineHeight: "22px" }}>RESERVE YOUR LOUNGE</a></li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <SideNavigation isOpen={isNavOpen} onClose={toggleNav} />
            <PanelMenu isOpen={showPanel} onClose={togglePanel} />

        </>
    );
};

